'use client';
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const DATA = [
  { day: 'Mar 20', incidents: 3, resolved: 3 },
  { day: 'Mar 21', incidents: 7, resolved: 6 },
  { day: 'Mar 22', incidents: 2, resolved: 2 },
  { day: 'Mar 23', incidents: 5, resolved: 5 },
  { day: 'Mar 24', incidents: 11, resolved: 9 },
  { day: 'Mar 25', incidents: 4, resolved: 4 },
  { day: 'Mar 26', incidents: 8, resolved: 7 },
  { day: 'Mar 27', incidents: 6, resolved: 6 },
  { day: 'Mar 28', incidents: 3, resolved: 3 },
  { day: 'Mar 29', incidents: 9, resolved: 8 },
  { day: 'Mar 30', incidents: 14, resolved: 11 },
  { day: 'Mar 31', incidents: 5, resolved: 5 },
  { day: 'Apr 1', incidents: 7, resolved: 7 },
  { day: 'Apr 2', incidents: 4, resolved: 3 },
];

function CustomTooltip({ active, payload, label }: any) {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        backgroundColor: '#161b22',
        border: '1px solid #2d3748',
        borderRadius: '6px',
        padding: '8px 12px',
      }}
    >
      <div className="font-mono" style={{ fontSize: '10px', color: '#64748b', marginBottom: '4px' }}>{label}</div>
      <div className="font-mono" style={{ fontSize: '12px', color: '#8b5cf6' }}>
        Incidents: {payload[0]?.value}
      </div>
      <div className="font-mono" style={{ fontSize: '12px', color: '#10b981' }}>
        Resolved: {payload[1]?.value}
      </div>
    </div>
  );
}

export default function DiagnosisHistoryChart() {
  return (
    <ResponsiveContainer width="100%" height={120}>
      <BarChart data={DATA} barGap={2} barSize={8}>
        <XAxis
          dataKey="day"
          tick={{ fontSize: 9, fill: '#374151', fontFamily: 'JetBrains Mono' }}
          axisLine={false}
          tickLine={false}
          interval={3}
        />
        <YAxis hide />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(255,255,255,0.03)' }} />
        <Bar dataKey="incidents" fill="#8b5cf650" radius={[2, 2, 0, 0]} />
        <Bar dataKey="resolved" fill="#10b981" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}